import { get, writable } from "svelte/store";
import { SubmissionService } from "../../services/submission.service";
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    await loadScores();
}
export async function loadScores() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _resp = await SubmissionService.getUsersScores(_filter);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function search() {
    //pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadScores();
}
